/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { UIChart } from 'primeng/chart';
import { LANGUAGES } from 'src/app/conf/languages';
import { DeviceBus } from 'src/app/model/device-bus';
import { AppState } from 'src/app/store/app.reducer';
import * as UserActions from 'src/app/store/user/user.actions';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { Observable, Subscription } from 'rxjs';
import { User } from 'src/app/model/user';
import { selectUser } from 'src/app/store/user/user.selector';

@Component({
	selector: 'app-bus-calculation',
	templateUrl: './bus-calculation.component.html',
})
export class BusCalculationComponent implements OnInit, OnDestroy {
	@ViewChild('total') chart: UIChart;

	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;

	listBus: DeviceBus[];
	busSelect: DeviceBus | undefined;

	listFotocellule: DeviceBus[];
	listSelettori: DeviceBus[];
	listInterfaccie: DeviceBus[];
	listLampeggianti: DeviceBus[];


	maxFotocellule: number;
	maxSelettori: number;
	maxInterfaccie: number;
	maxLampeggianti: number;

	totalFotocellule: number;
	totalSelettori: number;
	totalInterfaccie: number;
	totalLampeggianti: number;

	totalLoadFotocellule: number;
	totalLoadSelettori: number;
	totalLoadInterfaccie: number;
	totalLoadLampeggianti: number;
	totalLoadBus: number;


	totalLoadFotocellulePercentage: number;
	totalLoadSelettoriPercentage: number;
	totalLoadInterfacciePercentage: number;
	totalLoadLampeggiantiPercentage: number;
	totalLoadBusPercentage: number;

	ZLX24 = new DeviceBus(1, 'Quadri', 'ZLX24', 40, []);
	ZL392 = new DeviceBus(2, 'Quadri', 'ZL392', 25, []);
	ZBC1 = new DeviceBus(3, 'Quadri', 'ZBC1', 40, []);
	ZBB3 = new DeviceBus(4, 'Quadri', 'ZBB3', 40, []);
	RBE24 = new DeviceBus(5, 'Quadri', 'RBE24 PLUS', 12, []);
	RBE230 = new DeviceBus(6, 'Quadri', 'RBE230 PLUS', 12, []);
	ZLB24 = new DeviceBus(7, 'Quadri', 'ZLB24', 40, []);
	ZLX230 = new DeviceBus(8, 'Quadri', 'ZLX230', 40, []);
	// TODO: verificare cxn e compatibilità accessori con valori ufficiali
	ZBC3 = new DeviceBus(9, 'Quadri', 'ZBC3', 40, []);
	ZBA2 = new DeviceBus(10, 'Quadri', 'ZBA2', 40, []);
	ZBI1 = new DeviceBus(11, 'Quadri', 'ZBI1', 40, []);



	browserDeviceScreen = 960;

	visibleCameInfo = true;


	totalChart: any;
	totalOptions: any;

	guest = true;

	/*doughnutChartLabels: Label[] = [];
	doughnutChartData: MultiDataSet = [[]];
	doughnutChartType: ChartType = 'doughnut';
	colors: Color[] = [{backgroundColor: ['orange', 'green', 'blue', 'pink', 'grey']}];*/

	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MIN_MD_WIDTH_EXT = 670;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_COL4 = 1530;
	MIN_WIDTH_MX7 = 1700;

	doughnutChartOptions = {
		legend: {
			display: true,
			position: 'bottom',
			onClick: (e) => e.stopPropagation(),
		},
		tooltips: {
			callbacks: {
				label: (tooltipItem, data) => this.tooltips(tooltipItem),
				title: () => null,
			}
		},
	};

	constructor(
		private route: ActivatedRoute,
		private translate: TranslateService,
		private store: Store<AppState>
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.user$ = this.store.select(selectUser);
	}

	ngOnDestroy(): void {
		this.userSub?.unsubscribe();
	}

	ngOnInit() {
		this.userSub = this.user$?.subscribe(currentUser => {
			if (currentUser !== undefined && currentUser.Email !== undefined && currentUser.Email !== '') {
				this.guest = false;
			}
		});
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'BUS_PAGE_TITLE'
		}));
		const lang = this.route.snapshot.queryParamMap.get('language');
		const langVal = LANGUAGES.find(l => l.code === lang);
		if (langVal !== undefined) {
			this.store.dispatch(UserActions.setCurrentLang({ lang: langVal }));
			if (langVal.code !== this.translate.currentLang && localStorage != null) {
				window.location.reload();
			}
		}

		const doughnutChartLabels = [this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalFotocellule + '): ' + this.totalLoadFotocellulePercentage + '%'];
		doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS') + ' (' + this.totalSelettori + '): ' + this.totalLoadSelettoriPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_INTERFACES') + ' (' + this.totalInterfaccie + '): ' + this.totalLoadInterfacciePercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_FLASHING') + ' (' + this.totalLampeggianti + '): ' + this.totalLoadLampeggiantiPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_AVAILABLE') + ': ' + 100 + '%');

		const documentStyle = getComputedStyle(document.documentElement);

		this.totalChart = {
			labels: doughnutChartLabels,
			datasets: [
				{
					// label: [this.translate.instant('BUS_PHOTOCELLS'),'BUS_SELECTORS','BUS_INTERFACES','BUS_FLASHING','BUS_AVAILABLE'],
					data: [0, 0, 0, 0, 100],
					backgroundColor: [documentStyle.getPropertyValue('--yellow-600'), documentStyle.getPropertyValue('--green-600'), documentStyle.getPropertyValue('--blue-600'), documentStyle.getPropertyValue('--purple-600'), documentStyle.getPropertyValue('--blueGrey-600')],
					borderWidth: 0,
				},
			],
		};

		this.totalOptions = {
			plugins: {
				legend: {
					display: false,
				},
			},
			responsive: true,
			cutout: '60%',
			animation: false
		};

		this.browserDeviceScreen = window.screen.width;
		this.listBus = [];
		this.listBus.push(this.ZLX24);
		this.listBus.push(this.ZL392);
		this.listBus.push(this.ZBC1);
		this.listBus.push(this.ZBB3);
		this.listBus.push(this.RBE24);
		this.listBus.push(this.RBE230);
		this.listBus.push(this.ZLB24);
		this.listBus.push(this.ZLX230);
		// TODO: ZBC3 / ZBA2 / ZBI1 — cxn e listBusActive accessori ancora da confermare
		this.listBus.push(this.ZBC3);
		this.listBus.push(this.ZBA2);
		this.listBus.push(this.ZBI1);
		this.listBus.sort((a, b) => a.name.localeCompare(b.name));
		this.busSelect = this.listBus[0];

		// TODO: confermare se ZBC3 / ZBA2 / ZBI1 supportano tutti gli accessori sotto (aggiunti in via provvisoria)
		this.listFotocellule = [];
		this.listFotocellule.push(new DeviceBus(1, 'Fotocellule', 'BUS_CALC_PHO_DLX_BUS', 1,
			[this.ZLX24.id, this.ZL392.id, this.ZBC1.id, this.ZBB3.id, this.RBE24.id, this.RBE230.id, this.ZLB24.id, this.ZLX230.id, this.ZBC3.id, this.ZBA2.id, this.ZBI1.id]));
		this.listFotocellule.push(new DeviceBus(2, 'Fotocellule', 'BUS_CALC_PHO_DXR_BUS', 1,
			[this.ZLX24.id, this.ZL392.id, this.ZBC1.id, this.ZBB3.id, this.RBE24.id, this.RBE230.id, this.ZLB24.id, this.ZLX230.id, this.ZBC3.id, this.ZBA2.id, this.ZBI1.id]));

		this.listSelettori = [];
		this.listSelettori.push(new DeviceBus(1, 'Selettori', 'BUS_CALC_SEL_KEYPAD', 1,
			[this.ZLX24.id, this.ZL392.id, this.ZBC1.id, this.ZBB3.id, this.RBE24.id, this.RBE230.id, this.ZLB24.id, this.ZLX230.id, this.ZBC3.id, this.ZBA2.id, this.ZBI1.id]));
		this.listSelettori.push(new DeviceBus(2, 'Selettori', 'BUS_CALC_SEL_RFID_TRA', 1,
			[this.ZLX24.id, this.ZL392.id, this.ZBC1.id, this.ZBB3.id, this.RBE24.id, this.RBE230.id, this.ZLB24.id, this.ZLX230.id, this.ZBC3.id, this.ZBA2.id, this.ZBI1.id]));
		this.listSelettori.push(new DeviceBus(3, 'Selettori', 'BUS_CALC_SEL_MIFARE_TRA', 3,
			[this.ZLX24.id, this.ZL392.id, this.ZBC1.id, this.ZBB3.id, this.RBE24.id, this.RBE230.id, this.ZLB24.id, this.ZLX230.id, this.ZBC3.id, this.ZBA2.id, this.ZBI1.id]));
		this.listSelettori.push(new DeviceBus(4, 'Selettori', 'BUS_CALC_SEL_BLE', 2,
			[this.ZLX24.id, this.ZL392.id, this.ZBC1.id, this.ZBB3.id, this.ZLB24.id, this.ZLX230.id, this.ZBC3.id, this.ZBA2.id, this.ZBI1.id]));
		this.listSelettori.push(new DeviceBus(5, 'Selettori', 'BUS_CALC_SEL_KEY_SEL', 1,
			[this.ZLX24.id, this.ZL392.id, this.ZBC1.id, this.ZBB3.id, this.RBE24.id, this.RBE230.id, this.ZLB24.id, this.ZLX230.id, this.ZBC3.id, this.ZBA2.id, this.ZBI1.id]));

		this.listInterfaccie = [];
		this.listInterfaccie.push(new DeviceBus(1, 'Interfacce', 'BUS_CALC_INT_MODULE', 2,
			[this.ZLX24.id, this.ZL392.id, this.ZBC1.id, this.ZBB3.id, this.ZLB24.id, this.ZLX230.id, this.ZBC3.id, this.ZBA2.id, this.ZBI1.id]));

		this.listLampeggianti = [];
		this.listLampeggianti.push(new DeviceBus(1, 'Lampeggianti', 'BUS_CALC_FLA_KRX', 10,
			[this.ZLX24.id, this.ZL392.id, this.ZBC1.id, this.ZBB3.id, this.ZLB24.id, this.ZLX230.id, this.ZBC3.id, this.ZBA2.id, this.ZBI1.id]));
		this.listLampeggianti.push(new DeviceBus(2, 'Lampeggianti', 'BUS_CALC_FLA_GW_KRX', 13,
			[this.ZLX24.id, this.ZL392.id, this.ZBC1.id, this.ZBB3.id, this.ZLB24.id, this.ZLX230.id, this.ZBC3.id, this.ZBA2.id, this.ZBI1.id]));

		this.maxFotocellule = 8;
		this.maxSelettori = 8;
		this.maxInterfaccie = 2;
		this.maxLampeggianti = 2;

		this.totalFotocellule = 0;
		this.totalSelettori = 0;
		this.totalInterfaccie = 0;
		this.totalLampeggianti = 0;


		this.totalLoadBus = 0;
		this.totalLoadFotocellule = 0;
		this.totalLoadSelettori = 0;
		this.totalLoadInterfaccie = 0;
		this.totalLoadLampeggianti = 0;


		this.totalLoadBusPercentage = 0;
		this.totalLoadFotocellulePercentage = 0;
		this.totalLoadSelettoriPercentage = 0;
		this.totalLoadInterfacciePercentage = 0;
		this.totalLoadLampeggiantiPercentage = 0;
		this.calculateDisabledAddDevice();

		this.translate.onLangChange.subscribe(() => {
			this.changeLegends();
		});

		/*this.totalLoadFotocellule.subscribe(() => {
			this.doughnutChartLabels = [];
			this.doughnutChartLabels.push(this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalLoadFotocellule +') ');
			this.doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS'));
			this.doughnutChartLabels.push(this.translate.instant('BUS_INTERFACES'));
			this.doughnutChartLabels.push(this.translate.instant('BUS_FLASHING'));
			this.doughnutChartLabels.push(this.translate.instant('BUS_AVAILABLE'));
		});*/

		const visibleCameInfoParam = this.route.snapshot.queryParamMap.get('cameInfo');
		if (visibleCameInfoParam != null && visibleCameInfoParam === 'false') {
			this.visibleCameInfo = false;
		}

		this.onResize();
	}

	resetForm(): void {
		/*
		ZLX24 = new DeviceBus(1, 'Quadri', 'ZLX24', 40, []);
		ZL392 = new DeviceBus(2, 'Quadri', 'ZL392', 25, []);
		ZBC1 = new DeviceBus(3, 'Quadri', 'ZBC1', 40, []);
		ZBB3 = new DeviceBus(4, 'Quadri', 'ZBB3', 40, []);
		RBE24 = new DeviceBus(5, 'Quadri', 'RBE24 PLUS', 12, []);
		RBE230 = new DeviceBus(6, 'Quadri', 'RBE230 PLUS', 12, []);
		ZLB24 = new DeviceBus(7, 'Quadri', 'ZLB24', 40, []);
		ZLX230 = new DeviceBus(8, 'Quadri', 'ZLX230', 40, []);
		// TODO: ZBC3 / ZBA2 / ZBI1 — aggiornare cxn quando disponibili i valori ufficiali
		ZBC3 = new DeviceBus(9, 'Quadri', 'ZBC3', 40, []);
		ZBA2 = new DeviceBus(10, 'Quadri', 'ZBA2', 40, []);
		ZBI1 = new DeviceBus(11, 'Quadri', 'ZBI1', 40, []);
		*/
		this.maxSelettori = 8;

		if (this.busSelect.id === 5 || this.busSelect.id === 6) { //RBE
			this.maxFotocellule = 8;
			this.maxInterfaccie = 0;
			this.maxLampeggianti = 0;
		} else {
			this.maxFotocellule = 8;
			this.maxInterfaccie = 2;
			this.maxLampeggianti = 2;
		}


		for (const device of this.listFotocellule) {
			device.quantity = 0;
		}
		for (const device of this.listSelettori) {
			device.quantity = 0;
		}
		for (const device of this.listInterfaccie) {
			device.quantity = 0;
		}
		for (const device of this.listLampeggianti) {
			device.quantity = 0;
		}
		this.totalFotocellule = 0;
		this.totalSelettori = 0;
		this.totalInterfaccie = 0;
		this.totalLampeggianti = 0;

		this.totalLoadBus = 0;
		this.totalLoadFotocellule = 0;
		this.totalLoadSelettori = 0;
		this.totalLoadInterfaccie = 0;
		this.totalLoadLampeggianti = 0;


		this.totalLoadBusPercentage = 0;
		this.totalLoadFotocellulePercentage = 0;
		this.totalLoadSelettoriPercentage = 0;
		this.totalLoadInterfacciePercentage = 0;
		this.totalLoadLampeggiantiPercentage = 0;
		this.calculateDisabledAddDevice();
	}

	changeLegends(): void {
		/*const available = this.busSelect.cxn-this.totalLoadBus;
		const availablePercentage = 100 - this.totalLoadBusPercentage;*/
	}

	busChange(): void {
		this.resetForm();
		this.calculateDisabledAddDevice();
	}

	tooltips(tooltipItem: any): string {
		//const available = this.busSelect.cxn-this.totalLoadBus;
		const availablePercentage = 100 - this.totalLoadBusPercentage;
		switch (tooltipItem.index) {
			case 0: {
				return this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalFotocellule + '): ' + this.totalLoadFotocellulePercentage + '%';
			}
			case 1: {
				return this.translate.instant('BUS_SELECTORS') + ' (' + this.totalSelettori + '): ' + this.totalLoadSelettoriPercentage + '%';
			}
			case 2: {
				return this.translate.instant('BUS_INTERFACES') + ' (' + this.totalInterfaccie + '): ' + this.totalLoadInterfacciePercentage + '%';
			}
			case 3: {
				return this.translate.instant('BUS_FLASHING') + ' (' + this.totalLampeggianti + '): ' + this.totalLoadLampeggiantiPercentage + '%';
			}
			case 4: {
				return this.translate.instant('BUS_AVAILABLE') + ': ' + availablePercentage + '%';
			}
		}
		return '-';
	}

	checkSelectable(device: DeviceBus) {
		if (device.listBusActive.includes(this.busSelect.id)) {
			return false;
		}
		return true;
	}

	subtractOne(device: DeviceBus) {
		if (device.quantity > 0) {
			device.quantity--;
			this.totalLoadBus = this.totalLoadBus - device.cxn;
			switch (device.family) {
				case 'Fotocellule': {
					this.totalLoadFotocellule = this.totalLoadFotocellule - device.cxn;
					this.totalFotocellule--;
					break;
				}
				case 'Selettori': {
					this.totalLoadSelettori = this.totalLoadSelettori - device.cxn;
					this.totalSelettori--;
					break;
				}
				case 'Interfacce': {
					this.totalLoadInterfaccie = this.totalLoadInterfaccie - device.cxn;
					this.totalInterfaccie--;
					break;
				}
				case 'Lampeggianti': {
					this.totalLoadLampeggianti = this.totalLoadLampeggianti - device.cxn;
					this.totalLampeggianti--;
					break;
				}
			}
		}
		this.calculateDisabledAddDevice();
	}

	addOne(device: DeviceBus) {
		device.quantity++;
		this.totalLoadBus = this.totalLoadBus + device.cxn;
		switch (device.family) {
			case 'Fotocellule': {
				this.totalLoadFotocellule = this.totalLoadFotocellule + device.cxn;
				this.totalFotocellule++;
				break;
			}
			case 'Selettori': {
				this.totalLoadSelettori = this.totalLoadSelettori + device.cxn;
				this.totalSelettori++;
				break;
			}
			case 'Interfacce': {
				this.totalLoadInterfaccie = this.totalLoadInterfaccie + device.cxn;
				this.totalInterfaccie++;
				break;
			}
			case 'Lampeggianti': {
				this.totalLoadLampeggianti = this.totalLoadLampeggianti + device.cxn;
				this.totalLampeggianti++;
				break;
			}
		}
		this.calculateDisabledAddDevice();
	}

	calculateDisabledAddDevice(): void {
		for (const bus of this.listBus) {
			bus.disableAdd = this.totalLoadBus > bus.cxn;
		}

		const delta = this.busSelect.cxn - this.totalLoadBus;
		for (const fotocellula of this.listFotocellule) {
			fotocellula.disableAdd = fotocellula.cxn > delta || this.totalFotocellule === this.maxFotocellule;
			fotocellula.disableRemove = fotocellula.quantity === 0;
		}
		for (const selettore of this.listSelettori) {
			selettore.disableAdd = selettore.cxn > delta || this.totalSelettori === this.maxSelettori;
			selettore.disableRemove = selettore.quantity === 0;
		}
		for (const interfaccia of this.listInterfaccie) {
			interfaccia.disableAdd = interfaccia.cxn > delta || this.totalInterfaccie === this.maxInterfaccie;
			interfaccia.disableRemove = interfaccia.quantity === 0;
		}
		for (const lampeggiante of this.listLampeggianti) {
			lampeggiante.disableAdd = lampeggiante.cxn > delta || this.totalLampeggianti === this.maxLampeggianti;
			lampeggiante.disableRemove = lampeggiante.quantity === 0;
		}


		this.totalLoadBusPercentage = Math.floor(this.totalLoadBus / this.busSelect.cxn * 100);
		this.totalLoadFotocellulePercentage = Math.floor(this.totalLoadFotocellule / this.busSelect.cxn * 100);
		this.totalLoadSelettoriPercentage = Math.floor(this.totalLoadSelettori / this.busSelect.cxn * 100);
		this.totalLoadInterfacciePercentage = Math.floor(this.totalLoadInterfaccie / this.busSelect.cxn * 100);
		this.totalLoadLampeggiantiPercentage = Math.floor(this.totalLoadLampeggianti / this.busSelect.cxn * 100);
		this.elaborateGraphic();
	}

	elaborateGraphic(): void {
		const doughnutChartLabels = [this.translate.instant('BUS_PHOTOCELLS') + ' (' + this.totalFotocellule + '): ' + this.totalLoadFotocellulePercentage + '%'];
		doughnutChartLabels.push(this.translate.instant('BUS_SELECTORS') + ' (' + this.totalSelettori + '): ' + this.totalLoadSelettoriPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_INTERFACES') + ' (' + this.totalInterfaccie + '): ' + this.totalLoadInterfacciePercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_FLASHING') + ' (' + this.totalLampeggianti + '): ' + this.totalLoadLampeggiantiPercentage + '%');
		doughnutChartLabels.push(this.translate.instant('BUS_AVAILABLE') + ': ' + 100 + '%');
		const delta = 100 - this.totalLoadBusPercentage;
		// eslint-disable-next-line max-len
		const arrayDataSet = [this.totalLoadFotocellulePercentage, this.totalLoadSelettoriPercentage, this.totalLoadInterfacciePercentage, this.totalLoadLampeggiantiPercentage, delta];

		this.totalChart = {
			labels: doughnutChartLabels,
			datasets: [
				{
					data: arrayDataSet,
					backgroundColor: ['orange', 'green', 'blue', 'pink', 'grey'],
					borderWidth: 0,
				},
			],
		};
		/*this.totalChart = {
			datasets: [
				{
					data: arrayDataSet,
					backgroundColor: ['orange', 'green', 'blue', 'pink', 'grey'],
					borderWidth: 0,
				},
			],
		};*/
		/* this.doughnutChartData=  [arrayDataSet];
		this.changeLegends();*/
	}

	canAddAlertVisibleDevice(device: DeviceBus): boolean {
		if (device.cxn + this.totalLoadBus > this.busSelect.cxn) {
			return true;
		}
		return false;
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onMobile(): boolean {
		return this.screenWidth <= this.MIN_MD_WIDTH;
	}

	onMobileExt(): boolean {
		return this.screenWidth <= this.MIN_MD_WIDTH_EXT;
	}

	dynamicInputTextWidth(): string {
		return 'w-10rem h-2rem';
	}

	layoutMarginResponsive(): string {
		return (this.screenWidth >= this.MIN_WIDTH_MX7) ? "mx-7" : "mx-2";
	}
}
